import {
  TreeItemIndex,
  TreeItem,
  TreeItemRenderContext,
} from 'react-complex-tree'

import { Collection } from '@tribeplatform/react-sdk/types'

import { CollectionTreeItem } from '../components/CollectionTreeItem.js'
import { CollectionTreeItemData, TreeItems } from '../types.js'

type CollectionId = string
type CollectionSpacesTreeItems = Record<CollectionId, TreeItems>

export const COLLECTION_INDEX_PREFIX = 'collection-'

export function collectionTreeItemIndex(id: string) {
  return `${COLLECTION_INDEX_PREFIX}${id}`
}

export function createCollectionTreeItem({
  collection,
  children,
  setCollectionSpacesTreeItems,
  enableQuery,
}: {
  collection: Collection
  children: TreeItemIndex[]
  setCollectionSpacesTreeItems: (
    arg: (prev: CollectionSpacesTreeItems) => CollectionSpacesTreeItems,
  ) => void
  enableQuery: (context: TreeItemRenderContext) => boolean
}): TreeItem<CollectionTreeItemData> {
  return {
    index: collectionTreeItemIndex(collection.id),
    isFolder: true,
    data: {
      title: collection.name,
      type: 'collection',
      collection,
      render: ({ context }) => (
        <CollectionTreeItem
          collection={collection}
          enabled={enableQuery(context)}
          setSpaces={items =>
            setCollectionSpacesTreeItems(prev => ({
              ...prev,
              [collection.id]: items,
            }))
          }
        />
      ),
    },
    children,
  }
}
